// extracted by mini-css-extract-plugin
export default {"main_root":"NavigationBottom_main_root__e+u8j","root":"NavigationBottom_root__ec+Bg","selected":"NavigationBottom_selected__J9w5S"};